import { MslInfo } from './msl-info';

export class FeatureFlagInfo {
  siteId: number = 0;
  AccessGroupId: number = 0;
  msl!: MslInfo;
}
